package com.eladfinish.bible.contest

import dev.icerock.moko.resources.ImageResource
import kotlin.collections.List

internal object CommonMainImages1 {
  internal val ic_letter_bg: ImageResource by lazy { init_ic_letter_bg() }

  internal val ic_light_bulb_on: ImageResource by lazy { init_ic_light_bulb_on() }

  internal val ic_light_bulb_on_menu: ImageResource by lazy { init_ic_light_bulb_on_menu() }

  internal val ic_magnify_minus: ImageResource by lazy { init_ic_magnify_minus() }

  internal val ic_magnify_plus: ImageResource by lazy { init_ic_magnify_plus() }

  internal val ic_magnify_search: ImageResource by lazy { init_ic_magnify_search() }

  internal val ic_magnify_search_24: ImageResource by lazy { init_ic_magnify_search_24() }

  internal val ic_magnify_search_48_black: ImageResource by lazy { init_ic_magnify_search_48_black()
      }

  internal val ic_menu: ImageResource by lazy { init_ic_menu() }

  internal val ic_move: ImageResource by lazy { init_ic_move() }

  internal val ic_paste: ImageResource by lazy { init_ic_paste() }

  internal val ic_pencil_edit: ImageResource by lazy { init_ic_pencil_edit() }

  internal val ic_playlist_play: ImageResource by lazy { init_ic_playlist_play() }

  internal val ic_question_class_note_symbol: ImageResource by lazy {
      init_ic_question_class_note_symbol() }

  internal val ic_rename_box_black: ImageResource by lazy { init_ic_rename_box_black() }

  internal val ic_reorder_grid: ImageResource by lazy { init_ic_reorder_grid() }

  internal val ic_save_black: ImageResource by lazy { init_ic_save_black() }

  internal val ic_screen_about: ImageResource by lazy { init_ic_screen_about() }

  internal val ic_screen_browse: ImageResource by lazy { init_ic_screen_browse() }

  internal val ic_screen_complete_chapter: ImageResource by lazy { init_ic_screen_complete_chapter()
      }

  internal val ic_screen_complete_verse: ImageResource by lazy { init_ic_screen_complete_verse() }

  internal val ic_screen_exit: ImageResource by lazy { init_ic_screen_exit() }

  internal val ic_screen_help: ImageResource by lazy { init_ic_screen_help() }

  internal val ic_screen_mikud: ImageResource by lazy { init_ic_screen_mikud() }

  internal val ic_screen_misc: ImageResource by lazy { init_ic_screen_misc() }

  internal val ic_screen_multiple_choice_questions: ImageResource by lazy {
      init_ic_screen_multiple_choice_questions() }

  internal val ic_screen_names: ImageResource by lazy { init_ic_screen_names() }

  internal val ic_screen_pair_matching: ImageResource by lazy { init_ic_screen_pair_matching() }

  internal val ic_screen_recordings: ImageResource by lazy { init_ic_screen_recordings() }

  internal val ic_screen_reorder: ImageResource by lazy { init_ic_screen_reorder() }

  internal val ic_screen_search: ImageResource by lazy { init_ic_screen_search() }

  internal val ic_screen_title_activity_settings: ImageResource by lazy {
      init_ic_screen_title_activity_settings() }

  internal val ic_screen_winners_list: ImageResource by lazy { init_ic_screen_winners_list() }

  internal val ic_select_all: ImageResource by lazy { init_ic_select_all() }

  internal val ic_settings_black: ImageResource by lazy { init_ic_settings_black() }

  internal val ic_sort_alphabetical: ImageResource by lazy { init_ic_sort_alphabetical() }

  internal val ic_trash: ImageResource by lazy { init_ic_trash() }

  internal val option_a: ImageResource by lazy { init_option_a() }

  internal val option_b: ImageResource by lazy { init_option_b() }

  internal val option_c: ImageResource by lazy { init_option_c() }

  internal val option_d: ImageResource by lazy { init_option_d() }

  internal val parchment_background: ImageResource by lazy { init_parchment_background() }

  internal val parchment_verse: ImageResource by lazy { init_parchment_verse() }

  internal val pic: ImageResource by lazy { init_pic() }

  internal val progress_image: ImageResource by lazy { init_progress_image() }

  internal val pyramid_tile_selected_test: ImageResource by lazy { init_pyramid_tile_selected_test()
      }

  internal val pyramid_tile_test: ImageResource by lazy { init_pyramid_tile_test() }

  internal val shared_parchment_background: ImageResource by lazy {
      init_shared_parchment_background() }

  internal val space: ImageResource by lazy { init_space() }

  internal fun values(): List<ImageResource> = listOf(ic_letter_bg, ic_light_bulb_on,
      ic_light_bulb_on_menu, ic_magnify_minus, ic_magnify_plus, ic_magnify_search,
      ic_magnify_search_24, ic_magnify_search_48_black, ic_menu, ic_move, ic_paste, ic_pencil_edit,
      ic_playlist_play, ic_question_class_note_symbol, ic_rename_box_black, ic_reorder_grid,
      ic_save_black, ic_screen_about, ic_screen_browse, ic_screen_complete_chapter,
      ic_screen_complete_verse, ic_screen_exit, ic_screen_help, ic_screen_mikud, ic_screen_misc,
      ic_screen_multiple_choice_questions, ic_screen_names, ic_screen_pair_matching,
      ic_screen_recordings, ic_screen_reorder, ic_screen_search, ic_screen_title_activity_settings,
      ic_screen_winners_list, ic_select_all, ic_settings_black, ic_sort_alphabetical, ic_trash,
      option_a, option_b, option_c, option_d, parchment_background, parchment_verse, pic,
      progress_image, pyramid_tile_selected_test, pyramid_tile_test, shared_parchment_background,
      space)
}

private fun init_ic_letter_bg(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_letter_bg.svg\")") as String, fileName = "ic_letter_bg.svg")

private fun init_ic_light_bulb_on(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_light_bulb_on.svg\")") as String, fileName = "ic_light_bulb_on.svg")

private fun init_ic_light_bulb_on_menu(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_light_bulb_on_menu.svg\")") as String, fileName =
    "ic_light_bulb_on_menu.svg")

private fun init_ic_magnify_minus(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_magnify_minus.svg\")") as String, fileName = "ic_magnify_minus.svg")

private fun init_ic_magnify_plus(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_magnify_plus.svg\")") as String, fileName = "ic_magnify_plus.svg")

private fun init_ic_magnify_search(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_magnify_search.svg\")") as String, fileName = "ic_magnify_search.svg")

private fun init_ic_magnify_search_24(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_magnify_search_24.svg\")") as String, fileName =
    "ic_magnify_search_24.svg")

private fun init_ic_magnify_search_48_black(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_magnify_search_48_black.svg\")") as String, fileName =
    "ic_magnify_search_48_black.svg")

private fun init_ic_menu(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_menu.svg\")") as String, fileName = "ic_menu.svg")

private fun init_ic_move(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_move.svg\")") as String, fileName = "ic_move.svg")

private fun init_ic_paste(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_paste.svg\")") as String, fileName = "ic_paste.svg")

private fun init_ic_pencil_edit(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_pencil_edit.svg\")") as String, fileName = "ic_pencil_edit.svg")

private fun init_ic_playlist_play(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_playlist_play.svg\")") as String, fileName = "ic_playlist_play.svg")

private fun init_ic_question_class_note_symbol(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_question_class_note_symbol.svg\")") as String, fileName =
    "ic_question_class_note_symbol.svg")

private fun init_ic_rename_box_black(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_rename_box_black.svg\")") as String, fileName =
    "ic_rename_box_black.svg")

private fun init_ic_reorder_grid(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_reorder_grid.svg\")") as String, fileName = "ic_reorder_grid.svg")

private fun init_ic_save_black(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_save_black.svg\")") as String, fileName = "ic_save_black.svg")

private fun init_ic_screen_about(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_screen_about.svg\")") as String, fileName = "ic_screen_about.svg")

private fun init_ic_screen_browse(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_screen_browse.svg\")") as String, fileName = "ic_screen_browse.svg")

private fun init_ic_screen_complete_chapter(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_screen_complete_chapter.svg\")") as String, fileName =
    "ic_screen_complete_chapter.svg")

private fun init_ic_screen_complete_verse(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_screen_complete_verse.svg\")") as String, fileName =
    "ic_screen_complete_verse.svg")

private fun init_ic_screen_exit(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_screen_exit.svg\")") as String, fileName = "ic_screen_exit.svg")

private fun init_ic_screen_help(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_screen_help.svg\")") as String, fileName = "ic_screen_help.svg")

private fun init_ic_screen_mikud(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_screen_mikud.svg\")") as String, fileName = "ic_screen_mikud.svg")

private fun init_ic_screen_misc(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_screen_misc.svg\")") as String, fileName = "ic_screen_misc.svg")

private fun init_ic_screen_multiple_choice_questions(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_screen_multiple_choice_questions.svg\")") as String, fileName =
    "ic_screen_multiple_choice_questions.svg")

private fun init_ic_screen_names(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_screen_names.svg\")") as String, fileName = "ic_screen_names.svg")

private fun init_ic_screen_pair_matching(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_screen_pair_matching.svg\")") as String, fileName =
    "ic_screen_pair_matching.svg")

private fun init_ic_screen_recordings(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_screen_recordings.svg\")") as String, fileName =
    "ic_screen_recordings.svg")

private fun init_ic_screen_reorder(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_screen_reorder.svg\")") as String, fileName = "ic_screen_reorder.svg")

private fun init_ic_screen_search(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_screen_search.svg\")") as String, fileName = "ic_screen_search.svg")

private fun init_ic_screen_title_activity_settings(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_screen_title_activity_settings.svg\")") as String, fileName =
    "ic_screen_title_activity_settings.svg")

private fun init_ic_screen_winners_list(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_screen_winners_list.svg\")") as String, fileName =
    "ic_screen_winners_list.svg")

private fun init_ic_select_all(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_select_all.svg\")") as String, fileName = "ic_select_all.svg")

private fun init_ic_settings_black(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_settings_black.svg\")") as String, fileName = "ic_settings_black.svg")

private fun init_ic_sort_alphabetical(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_sort_alphabetical.svg\")") as String, fileName =
    "ic_sort_alphabetical.svg")

private fun init_ic_trash(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/ic_trash.svg\")") as String, fileName = "ic_trash.svg")

private fun init_option_a(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/option_a.png\")") as String, fileName = "option_a.png")

private fun init_option_b(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/option_b.png\")") as String, fileName = "option_b.png")

private fun init_option_c(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/option_c.png\")") as String, fileName = "option_c.png")

private fun init_option_d(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/option_d.png\")") as String, fileName = "option_d.png")

private fun init_parchment_background(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/parchment_background.png\")") as String, fileName =
    "parchment_background.png")

private fun init_parchment_verse(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/parchment_verse.png\")") as String, fileName = "parchment_verse.png")

private fun init_pic(): ImageResource = ImageResource(fileUrl = js("require(\"./images/pic.jpg\")")
    as String, fileName = "pic.jpg")

private fun init_progress_image(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/progress_image.png\")") as String, fileName = "progress_image.png")

private fun init_pyramid_tile_selected_test(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/pyramid_tile_selected_test.svg\")") as String, fileName =
    "pyramid_tile_selected_test.svg")

private fun init_pyramid_tile_test(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/pyramid_tile_test.svg\")") as String, fileName = "pyramid_tile_test.svg")

private fun init_shared_parchment_background(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/shared_parchment_background.png\")") as String, fileName =
    "shared_parchment_background.png")

private fun init_space(): ImageResource = ImageResource(fileUrl =
    js("require(\"./images/space.png\")") as String, fileName = "space.png")

public actual val SharedRes.images.ic_letter_bg: ImageResource
  get() = CommonMainImages1.ic_letter_bg

public actual val SharedRes.images.ic_light_bulb_on: ImageResource
  get() = CommonMainImages1.ic_light_bulb_on

public actual val SharedRes.images.ic_light_bulb_on_menu: ImageResource
  get() = CommonMainImages1.ic_light_bulb_on_menu

public actual val SharedRes.images.ic_magnify_minus: ImageResource
  get() = CommonMainImages1.ic_magnify_minus

public actual val SharedRes.images.ic_magnify_plus: ImageResource
  get() = CommonMainImages1.ic_magnify_plus

public actual val SharedRes.images.ic_magnify_search: ImageResource
  get() = CommonMainImages1.ic_magnify_search

public actual val SharedRes.images.ic_magnify_search_24: ImageResource
  get() = CommonMainImages1.ic_magnify_search_24

public actual val SharedRes.images.ic_magnify_search_48_black: ImageResource
  get() = CommonMainImages1.ic_magnify_search_48_black

public actual val SharedRes.images.ic_menu: ImageResource
  get() = CommonMainImages1.ic_menu

public actual val SharedRes.images.ic_move: ImageResource
  get() = CommonMainImages1.ic_move

public actual val SharedRes.images.ic_paste: ImageResource
  get() = CommonMainImages1.ic_paste

public actual val SharedRes.images.ic_pencil_edit: ImageResource
  get() = CommonMainImages1.ic_pencil_edit

public actual val SharedRes.images.ic_playlist_play: ImageResource
  get() = CommonMainImages1.ic_playlist_play

public actual val SharedRes.images.ic_question_class_note_symbol: ImageResource
  get() = CommonMainImages1.ic_question_class_note_symbol

public actual val SharedRes.images.ic_rename_box_black: ImageResource
  get() = CommonMainImages1.ic_rename_box_black

public actual val SharedRes.images.ic_reorder_grid: ImageResource
  get() = CommonMainImages1.ic_reorder_grid

public actual val SharedRes.images.ic_save_black: ImageResource
  get() = CommonMainImages1.ic_save_black

public actual val SharedRes.images.ic_screen_about: ImageResource
  get() = CommonMainImages1.ic_screen_about

public actual val SharedRes.images.ic_screen_browse: ImageResource
  get() = CommonMainImages1.ic_screen_browse

public actual val SharedRes.images.ic_screen_complete_chapter: ImageResource
  get() = CommonMainImages1.ic_screen_complete_chapter

public actual val SharedRes.images.ic_screen_complete_verse: ImageResource
  get() = CommonMainImages1.ic_screen_complete_verse

public actual val SharedRes.images.ic_screen_exit: ImageResource
  get() = CommonMainImages1.ic_screen_exit

public actual val SharedRes.images.ic_screen_help: ImageResource
  get() = CommonMainImages1.ic_screen_help

public actual val SharedRes.images.ic_screen_mikud: ImageResource
  get() = CommonMainImages1.ic_screen_mikud

public actual val SharedRes.images.ic_screen_misc: ImageResource
  get() = CommonMainImages1.ic_screen_misc

public actual val SharedRes.images.ic_screen_multiple_choice_questions: ImageResource
  get() = CommonMainImages1.ic_screen_multiple_choice_questions

public actual val SharedRes.images.ic_screen_names: ImageResource
  get() = CommonMainImages1.ic_screen_names

public actual val SharedRes.images.ic_screen_pair_matching: ImageResource
  get() = CommonMainImages1.ic_screen_pair_matching

public actual val SharedRes.images.ic_screen_recordings: ImageResource
  get() = CommonMainImages1.ic_screen_recordings

public actual val SharedRes.images.ic_screen_reorder: ImageResource
  get() = CommonMainImages1.ic_screen_reorder

public actual val SharedRes.images.ic_screen_search: ImageResource
  get() = CommonMainImages1.ic_screen_search

public actual val SharedRes.images.ic_screen_title_activity_settings: ImageResource
  get() = CommonMainImages1.ic_screen_title_activity_settings

public actual val SharedRes.images.ic_screen_winners_list: ImageResource
  get() = CommonMainImages1.ic_screen_winners_list

public actual val SharedRes.images.ic_select_all: ImageResource
  get() = CommonMainImages1.ic_select_all

public actual val SharedRes.images.ic_settings_black: ImageResource
  get() = CommonMainImages1.ic_settings_black

public actual val SharedRes.images.ic_sort_alphabetical: ImageResource
  get() = CommonMainImages1.ic_sort_alphabetical

public actual val SharedRes.images.ic_trash: ImageResource
  get() = CommonMainImages1.ic_trash

public actual val SharedRes.images.option_a: ImageResource
  get() = CommonMainImages1.option_a

public actual val SharedRes.images.option_b: ImageResource
  get() = CommonMainImages1.option_b

public actual val SharedRes.images.option_c: ImageResource
  get() = CommonMainImages1.option_c

public actual val SharedRes.images.option_d: ImageResource
  get() = CommonMainImages1.option_d

public actual val SharedRes.images.parchment_background: ImageResource
  get() = CommonMainImages1.parchment_background

public actual val SharedRes.images.parchment_verse: ImageResource
  get() = CommonMainImages1.parchment_verse

public actual val SharedRes.images.pic: ImageResource
  get() = CommonMainImages1.pic

public actual val SharedRes.images.progress_image: ImageResource
  get() = CommonMainImages1.progress_image

public actual val SharedRes.images.pyramid_tile_selected_test: ImageResource
  get() = CommonMainImages1.pyramid_tile_selected_test

public actual val SharedRes.images.pyramid_tile_test: ImageResource
  get() = CommonMainImages1.pyramid_tile_test

public actual val SharedRes.images.shared_parchment_background: ImageResource
  get() = CommonMainImages1.shared_parchment_background

public actual val SharedRes.images.space: ImageResource
  get() = CommonMainImages1.space
